// extracted by mini-css-extract-plugin
export var image = "styles-module--image--20a06";
export var loadingContainer = "styles-module--loadingContainer--923e4";